import { ref, get, set, runTransaction } from "firebase/database";
import { database as realtimeDB } from "../firebase";

// 応募カウントを増やす
export const incrementLineApply = async (user) => {
  if (!user) throw new Error("ユーザー未ログイン");

  const uid = user.uid;
  const todayKey = new Date().toISOString().slice(0, 10);
  const userGlobalRef = ref(realtimeDB, `users/${uid}/appliedDates`);
  const userTodayRef = ref(realtimeDB, `lineApplyCount/${todayKey}/users/${uid}`);
  const totalCountRef = ref(realtimeDB, "lineApplyCount/totalCount");
  const todayCountRef = ref(realtimeDB, `lineApplyCount/${todayKey}/count`);

  const userSnap = await get(userGlobalRef);
  const appliedDates = userSnap.exists() ? userSnap.val() : {};
  const alreadyApplied = Object.keys(appliedDates).length > 0;

  if (!appliedDates[todayKey]) {
    await set(userTodayRef, { appliedAt: Date.now() });
    await runTransaction(todayCountRef, (val) => (val || 0) + 1);
    if (!alreadyApplied) {
      await runTransaction(totalCountRef, (val) => (val || 0) + 1);
    }
    await set(ref(realtimeDB, `users/${uid}/appliedDates/${todayKey}`), Date.now());
    return { status: "applied", alreadyApplied: false };
  } else {
    return { status: "already", alreadyApplied: true };
  }
};

export const getTotalApplyCount = async () => {
  const countRef = ref(realtimeDB, "lineApplyCount/totalCount");
  const snap = await get(countRef);
  return snap.exists() ? snap.val() : 0;
};

export const getHasApplied = async (user) => {
  if (!user) return false;
  const userGlobalRef = ref(realtimeDB, `users/${user.uid}/appliedDates`);
  const userSnap = await get(userGlobalRef);
  return userSnap.exists() && Object.keys(userSnap.val()).length > 0;
};
